// extracted by mini-css-extract-plugin
module.exports = {"main-content":"myBookmarks_main-content__9wTne","ads-layout":"myBookmarks_ads-layout__5bvCv","empty":"myBookmarks_empty__WiqKE"};